declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const trackEvent = (event: string, params?: Record<string, any>) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      if (params) window.gtag("event", event, params);
      else window.gtag("event", event);
    }
  } catch {
    // fail safe
  }
};

/**
 * Emit an analytics event and reliably invoke `next` afterwards. Used for
 * events that immediately precede a hard navigation (OAuth redirect, Stripe
 * checkout redirect). Uses gtag's `event_callback` + `event_timeout` so the
 * dataLayer beacon has a chance to flush before the page tears down, with a
 * hard timeout fallback so navigation is never blocked if gtag is missing,
 * blocked, or slow.
 */
export const trackEventAndThen = (
  event: string,
  params: Record<string, any> | undefined,
  next: () => void,
) => {
  let called = false;
  const fire = () => {
    if (called) return;
    called = true;
    try {
      next();
    } catch {
      // caller owns its own errors
    }
  };
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, {
        ...(params ?? {}),
        event_callback: fire,
        event_timeout: 1500,
      });
      setTimeout(fire, 1500);
      return;
    }
  } catch {
    // fall through to fallback path
  }
  // gtag unavailable — still emit through the standard sink (no-op in prod
  // when gtag is missing, but observable in tests) then proceed immediately.
  trackEvent(event, params);
  fire();
};

export {};